export default "__VITE_ASSET__CxtoYW4l__"